import { render, staticRenderFns } from "./Impuesto.vue?vue&type=template&id=4d653cde&scoped=true"
import script from "./Impuesto.vue?vue&type=script&lang=js"
export * from "./Impuesto.vue?vue&type=script&lang=js"
import style0 from "./Impuesto.vue?vue&type=style&index=0&id=4d653cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d653cde",
  null
  
)

export default component.exports